export default {
  get(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 2) {
      return decodeURIComponent(parts.pop().split(';').shift());
    }

    return '';
  },
  getByRegex(regex) {
    const allCookies = document.cookie.split(';').map((item) => item.split('=')[0].trim());
    const foundCookies = allCookies.filter((item) => item.match(regex));

    return Object.fromEntries(foundCookies.map((cookie) => [cookie, this.get(cookie)]));
  },
  set(name, value, options = {}) {
    const modifiedOptions = {
      path: '/',
      ...options,
    };

    if (modifiedOptions.expires instanceof Date) {
      modifiedOptions.expires = modifiedOptions.expires.toUTCString();
    }

    let updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

    for (const optionKey in modifiedOptions) {
      updatedCookie += '; ' + optionKey;

      const optionValue = modifiedOptions[optionKey];

      if (optionValue !== true) {
        updatedCookie += '=' + optionValue;
      }
    }

    document.cookie = updatedCookie;
  },
  remove(name, options = {}) {
    this.set(name, '', { 'max-age': -1, ...options });
  },
  removeByRegex(regex, options = {}) {
    const foundCookies = this.getByRegex(regex);

    for (const cookie of Object.keys(foundCookies)) {
      this.remove(cookie, options);
    }
  },
};
